import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';

import { getBaseCreditDefaultValues } from './baseCredit';

export const getRatenkreditDefaultValues = (attribution: APPLICANT_ATTRIBUTION) => ({
    ...getBaseCreditDefaultValues(attribution),
    abloesen: false,
    bic: null,
    datumErsteZahlung: null,
    datumLetzteRate: null,
    iban: null,
    kreditinstitut: null,
    kreditLaufzeit: null,
    rateMonatlich: null,
    restschuld: null,
    schlussrate: null,
    urspruenglicherKreditbetrag: null,
    zinssatz: null,
});
